// const backendDomain = "http://192.168.1.237/oakya_cm_erp";
const backendDomain = "https://oakyacmerp.oakyaitservices.in/api"
const SummaryApi = {
  getAllStudents: {
    url: `${backendDomain}/student/adminretrieve.php`,
    method: "get",
  },
  getStudentImage: {
    url: `${backendDomain}/student/images/`,
  },
  createStudent: {
    url: `${backendDomain}/student/create.php`,
    method: "post",
  },
  updateStudent: {
    url: `${backendDomain}/student/update.php`,
    method: "post",
  },
  getAllDepartment: {
    url: `${backendDomain}/department/adminretrieve.php`,
    method: "get",
  },
  getdeptImages: {                                                  
    url: `${backendDomain}/department/images/`,
  },
  updateDepartment: {
    url: `${backendDomain}/department/update.php`,
    method: "post",
  },
  createDepartment: {
    url: `${backendDomain}/department/create.php`,
    method: "post",
  },
  getAllCourses: {
    url: `${backendDomain}/course/adminretrieve.php`,
    method: "get",
  },
  getCourseImages: {
    url: `${backendDomain}/course/images/`,
  },
  createCourse: {
    url: `${backendDomain}/course/create.php`,
    method: "post",
  },
  updateCourse: {
    url: `${backendDomain}/course/update.php`,
    method: "post",
  },
  getAllSections: {
    url: `${backendDomain}/section/adminretrieve.php`,
    method: "get",
  },
  createSections: {
    url: `${backendDomain}/section/create.php`,
    method: "post",
  },
  getAllProfessors:{
    url: `${backendDomain}/professor/adminretrieve.php`,
    method: "get",
  },
  getProfessorImage:{
    url: `${backendDomain}/professor/images/`,
  },
  createProfessor:{
    url: `${backendDomain}/professor/create.php`,
    method: "post",
  },
  updateProfessor:{
    url: `${backendDomain}/professor/update.php`,
    method: "post",
  },
  getAllNotification:{
    url: `${backendDomain}/notification/adminretrieve.php`,
    method: "get",
  },
updateNotification:{
  url: `${backendDomain}/notification/update.php`,
    method: "post",
},
createNotification:{
  url:`${backendDomain}/notification/create.php`,
  method:"post",
},
};

export default SummaryApi;
